var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18378",
    "data-name": "Group 18378",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4286",
    "data-name": "Rectangle 4286",
    transform: "translate(-0.002)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.002
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "java-4",
    transform: "translate(9.917 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29701",
    "data-name": "Path 29701",
    d: "M79.08,258.087s-2.577,1.5,1.834,2.006a38.588,38.588,0,0,0,13.963-.592,24.3,24.3,0,0,0,3.71,1.812c-13.2,5.658-29.876-.328-19.507-3.225M77.467,250.7s-2.89,2.139,1.524,2.6a54.472,54.472,0,0,0,18.016-.865,8,8,0,0,0,2.776,1.692c-15.961,4.667-33.738.368-22.316-3.423",
    transform: "translate(-63.063 -205.937)",
    fill: "#5382a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29702",
    "data-name": "Path 29702",
    d: "M155.194,98.648c3.253,3.745-.854,7.115-.854,7.115s8.259-4.264,4.466-9.6c-3.543-4.979-6.259-7.453,8.448-15.982,0,0-23.085,5.765-12.059,18.47",
    transform: "translate(-127.191 -66.405)",
    fill: "#e76f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29703",
    "data-name": "Path 29703",
    d: "M60.017,226.177s1.907,1.571-2.1,2.787c-7.62,2.308-31.714,3.005-38.407.092-2.406-1.047,2.106-2.5,3.525-2.8a9.152,9.152,0,0,1,2.326-.261c-2.676-1.885-17.3,3.7-7.426,5.3,26.915,4.365,49.063-1.965,42.082-5.115M31.812,205.684s-12.256,2.911-4.34,3.968c3.342.447,10,.346,16.211-.174,5.072-.428,10.165-1.337,10.165-1.337a21.527,21.527,0,0,0-3.082,1.649c-12.446,3.273-36.488,1.75-29.567-1.6a23.19,23.19,0,0,1,10.613-2.509M53.8,217.973c12.652-6.574,6.8-12.892,2.719-12.041a9.469,9.469,0,0,0-1.447.389,2.307,2.307,0,0,1,1.081-.834c8.077-2.84,14.289,8.375-2.607,12.817a1.1,1.1,0,0,0,.254-.331",
    transform: "translate(-14.555 -168.567)",
    fill: "#5382a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29704",
    "data-name": "Path 29704",
    d: "M118.32,4.4s7.007,7.009-6.645,17.787c-10.948,8.645-2.5,13.575,0,19.207-6.39-5.766-11.08-10.841-7.934-15.565,4.618-6.934,17.411-10.3,14.584-21.429",
    transform: "translate(-86.706 -4.399)",
    fill: "#e76f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29705",
    "data-name": "Path 29705",
    d: "M73.419,346.436c12.144.777,30.792-.431,31.234-6.177,0,0-.849,2.178-10.036,3.908a99.852,99.852,0,0,1-30.731.473s1.552,1.284,9.534,1.8",
    transform: "translate(-54.919 -279.215)",
    fill: "#5382a1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaIcon);
export default __webpack_public_path__ + "static/media/Java-icon.f983dcc89ff33f361a4284d6f256eb1a.svg";
export { ForwardRef as ReactComponent };